/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_POLICY_DETAIL = gql`
  query Query($input: GetPolicyDetailInput!) {
    getPolicyDetail(input: $input) {
      policyNumber
      productDefination
      countryToBeInsured
      type
      pdf
      premium
      coverage
      purchasedAt
      kycDoc {
        comment
        doc
        fileType
        name
        type
      }
      purchasedBy {
        vuid
        bankDetail {
          vuid
          accHolderName
          bankName
          accountNo
          type
          swiftCode
        }
        email
        firstName
        lastName
        fullName
        emailVerified
        image
        bannerImg
        address {
          addressLine1
          city
          country
        }
        occupation
        bio
        primaryContactNo
        kyc {
          doc
          name
          fileType
          status
          type
        }
        nationality
        suspended
        kycSubmitted
      }
      useOfProceeds {
        selected
        value
      }
      termsOfUse {
        selected
        value
      }
      benificiaryDetail {
        address {
          addressLine2
          city
          addressLine1
          country
        }
        email
        firstName
        lastName
        mobileNo
      }
    }
  }
`;
